import $ from 'jquery';
import { CROSS_BREAKPOINT, getBreakpoint, NAVIGATION } from './breakpoint-controller';
import { clearFocus } from './header';

const HOVER_TIMEOUT = 100;//ms
const UNHOVER_TIMEOUT = 150;//ms
const MOBILE = 'mobile';
const DESKTOP = 'desktop';

let mode = null;

var activateMenuTimeout = null;
var deactivateMenuTimeout = null;
var activateSubMenuTimeout = null;
var deactivateSubMenuTimeout = null;

let activeMenu = null;
let activeSubMenu = null;
let mainMenu = null;
let subMenus = null;
let subMenuToggles = null;

function onDocumentReady() {
	mainMenu = $('#main-menu');
	subMenus = mainMenu.find('.sub-menu');
	subMenuToggles = mainMenu.find('.sub-menu-toggle');

	$(document).on(CROSS_BREAKPOINT, onCrossBreakpoint).on('keyup', onKeyUp);
}

function onKeyUp(e) {
	if (e.key === 'Escape') {
		setActiveSubMenu(null);
		setActiveMenu(null);
	}
}

function onCrossBreakpoint(e, breakpoint) {
	if (breakpoint >= NAVIGATION) {
		setMode(DESKTOP);
	} else {
		setMode(MOBILE);
	}
}

function setMode(m) {
	if (mode === m) {
		return;
	}

	subMenus.attr('style', '');
	subMenuToggles.removeClass('active');

	mainMenu.on('click', '.sub-menu-toggle', onClickToggleSubMenu);

	switch (m) {
		case MOBILE:
			mainMenu.doubleTapToGo('destroy');

			mainMenu.on('click', '.menu-item-top-level > .menu-item-link', onClickMobileTopLevelItem);

			mainMenu.on('click', '.go-back', onClickGoBack);

			mainMenu.off('mouseenter', '.menu-item-top-level', onMouseEnter);
			mainMenu.off('mouseleave', '.menu-item-top-level', onMouseLeave);

			mainMenu.off('mouseenter', '.menu-item-level-2.menu-item-has-children', onMouseEnterSubMenu);
			mainMenu.off('mouseenter', '.menu-item-level-2 .menu-item', onMouseEnterSubMenuItem);
			mainMenu.off('mouseleave', '.sub-menu.sub-menu-level-2', onMouseLeaveSubMenu);

			break;

		case DESKTOP:
			mainMenu.off('click', '.menu-item-top-level > .menu-item-link', onClickMobileTopLevelItem);
			mainMenu.off('click', '.go-back', onClickGoBack);

			mainMenu.on('click', '.menu-item-top-level.active', onClickActiveTopLevelItem);
			mainMenu.on('mouseenter', '.menu-item-top-level', onMouseEnter);
			mainMenu.on('mouseleave', '.menu-item-top-level', onMouseLeave);

			mainMenu.on('mouseenter', '.menu-item-level-2.menu-item-has-children', onMouseEnterSubMenu);
			mainMenu.on('mouseenter', '.menu-item-level-2 .menu-item', onMouseEnterSubMenuItem);
			mainMenu.on('mouseleave', '.sub-menu.sub-menu-level-2', onMouseLeaveSubMenu);

			mainMenu.doubleTapToGo();
			break;
	}

	mode = m;
}

function onClickMobileTopLevelItem(e) {
	const $clicked = $(e.currentTarget);

	if ($clicked.attr('href') === '#') {
		$clicked.find('.sub-menu-toggle').trigger('click');
	}
}

function onClickActiveTopLevelItem() {
	setActiveSubMenu(null);
	setActiveMenu(null);
}

function onMouseEnter(e) {
	clearTimeout(deactivateMenuTimeout);

	activateMenuTimeout = setTimeout(() => {
		setActiveMenu(e.currentTarget);
	}, HOVER_TIMEOUT);
}

function onMouseLeave() {
	clearTimeout(activateMenuTimeout);

	deactivateMenuTimeout = setTimeout(() => {
		setActiveMenu(false);
	}, UNHOVER_TIMEOUT);
}

function setActiveMenu(menu) {
	let subMenu = null;
	clearFocus();

	if (menu === activeMenu) {
		return;
	}

	if (activeMenu) {
		activeMenu.classList.remove('active');
		$(activeMenu).children('.sub-menu').stop(true, false).slideUp();
	}

	if (menu) {
		menu.classList.add('active');
		subMenu = $(menu).children('.sub-menu');

		subMenu.stop(true, false).slideDown();
	}

	activeMenu = menu;

	if (mode === DESKTOP && subMenu && subMenu.hasClass('meganav-services')) {
		const firstSubMenu = subMenu
			.find('.menu-item-level-2 > .menu-item-link')
			.get(0);
		setActiveSubMenu(firstSubMenu);
	}
}

function onMouseEnterSubMenuItem() {
	clearTimeout(deactivateSubMenuTimeout);
	clearTimeout(activateSubMenuTimeout);
}

function onMouseEnterSubMenu(e) {
	clearTimeout(activateSubMenuTimeout);
	clearTimeout(deactivateSubMenuTimeout);

	activateSubMenuTimeout = setTimeout(() => {
		setActiveSubMenu(e.target);
	}, HOVER_TIMEOUT * 2);
}

function onMouseLeaveSubMenu() {
	clearTimeout(deactivateSubMenuTimeout);

	deactivateSubMenuTimeout = setTimeout(() => {
		setActiveSubMenu(false);
	}, UNHOVER_TIMEOUT);
}

function setActiveSubMenu(menu) {
	if (menu === activeSubMenu) {
		return;
	}

	if (activeMenu && $(activeMenu).children('.meganav-services').length > 0) {
		if (!$(menu).is('.menu-item-level-2 > .menu-item-link')) {
			return;
		}
	}

	if (activeSubMenu) {
		activeSubMenu.classList.remove('active');
		$(activeSubMenu).next('.sub-menu').stop(true, false).slideUp();
	}

	if (menu) {
		menu.classList.add('active');
		$(menu).next('.sub-menu').stop(true, false).slideDown();
	}

	activeSubMenu = menu;
}

function onClickToggleSubMenu(e) {
	const clicked = $(e.currentTarget);
	const itemLink = clicked.closest('.menu-item-link');

	clicked.toggleClass('active');
	itemLink.toggleClass('active');
	itemLink.next('.sub-menu').toggleClass('active');

	if (getBreakpoint() >= NAVIGATION) {
		itemLink.next('.sub-menu').slideToggle();
	}

	e.stopPropagation();
	e.preventDefault();
	return false;
}

function onClickGoBack(e) {
	$(e.currentTarget).closest('.sub-menu.active').removeClass('active');
}


document.addEventListener('DOMContentLoaded', onDocumentReady);
